import { render, staticRenderFns } from "./ListOfCongresses.vue?vue&type=template&id=34b1f508&scoped=true"
import script from "./ListOfCongresses.vue?vue&type=script&lang=js"
export * from "./ListOfCongresses.vue?vue&type=script&lang=js"
import style0 from "./ListOfCongresses.vue?vue&type=style&index=0&id=34b1f508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b1f508",
  null
  
)

export default component.exports